<template>
  <div :key="accessGroup.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'accessGroup',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.accessGroupId !== to.params.accessGroupId) {
            if (await this.getAccessGroupInfo(to.params.accessGroupId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getAccessGroupInfo: 'getAccessGroupInfo',
        }),
    },
};
</script>
